"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const BG_IMAGE = "/image/new-version/casting/Investment-Casting/post-casting-cnc-machining-bg.webp";

const SERVICE_KEYS = ["postCastingCncItem1", "postCastingCncItem2"] as const;

const CheckCircleIcon = () => (
	<svg className="mt-0.5 h-5 w-5 flex-shrink-0" viewBox="0 0 20 20" fill="none" aria-hidden="true">
		<circle cx="10" cy="10" r="8" fill="#ffffff" />
		<path
			d="M6.4 10.2L8.7 12.4L13.6 7.6"
			stroke="#80c26a"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default function PostCastingCncMachining() {
	const t = useTranslations("new-investment-casting");

	return (
		<section className="relative overflow-hidden bg-[#e8eaed] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="absolute inset-0">
				<Image
					src={BG_IMAGE}
					alt={t("postCastingCncImageAlt")}
					fill
					className="object-cover object-center"
					sizes="100vw"
					priority={false}
				/>
				<div className="absolute inset-0 bg-gradient-to-r from-[#80c26a] via-[#80c26a]/65 to-transparent" />
			</div>

			<div className="container relative z-10">
				<div className="max-w-xl lg:max-w-[55%]">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-white sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("postCastingCncTitle")}
					</h2>
					<p className="mb-6 text-sm leading-relaxed text-black md:text-base">{t("postCastingCncDesc")}</p>

					<h3 className="mb-4 text-base font-bold text-black sm:text-lg">
						{t("postCastingCncServicesLabel")}
					</h3>
					<ul className="space-y-3">
						{SERVICE_KEYS.map((key) => (
							<li key={key} className="flex items-start gap-3">
								<CheckCircleIcon />
								<span className="text-sm leading-relaxed text-black md:text-base">{t(key)}</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		</section>
	);
}
